import {
  HashRouter,
} from 'react-router-dom';
import countries from 'i18n-iso-countries';
import languages from '@cospired/i18n-iso-languages';
import CookieConsent from "react-cookie-consent";

import enCountries from 'i18n-iso-countries/langs/en.json';
import enLanguages from '@cospired/i18n-iso-languages/langs/en.json';

import 'antd/dist/antd.less';
import 'video.js/dist/video-js.css';
import './styles/global.scss';
import './styles/antdApp.scss';
import './styles/videojs.scss';

// Context providers
import AuthenticationDataProvider from './Helpers/AuthenticationDataProvider';
import AuthorizationDataProvider from './Helpers/AuthorizationDataProvider';
import IntlWrapperProvider from './Helpers/IntlWrapperProvider';
import PopupProvider from './Helpers/PopupProvider';

// Components
import Header from './components/Header/Header';
import SideNav from './components/SideNav/SideNav';

// Helpers
import Router from './Helpers/Router';
import {FormattedMessage} from "react-intl";

const App = () => {
  countries.registerLocale(enCountries);
  languages.registerLocale(enLanguages);

  return (
    <HashRouter>
    <IntlWrapperProvider>
      <AuthenticationDataProvider>
        <AuthorizationDataProvider>
          <PopupProvider>
            <div>
              <Header/>
              <SideNav/>
              <Router/>
							<CookieConsent 
								location="bottom" 
								style={{alignItems: "center", backgroundColor: "white", border: "1px solid #F5F0E7", color: "black", display: "flex"}}
								buttonStyle={{backgroundColor: "#3B95FF", borderRadius: '5px', color: "white", display: "flex"}}
								expires={365}
								buttonText="Allow"
							>
								<FormattedMessage id="cookie.consent" />
							</CookieConsent>
            </div>
          </PopupProvider>
        </AuthorizationDataProvider>
      </AuthenticationDataProvider>
      </IntlWrapperProvider>
			
		</HashRouter>
  );
}

export default App;